import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
@Component({
    selector: 'app-panoramica',
    templateUrl: './panoramica.component.html',
    styleUrls: ['./panoramica.component.scss'],
    standalone: false
})
export class PanoramicaComponent implements OnInit, OnDestroy {
    
  private _usuario!: Usuario;
  private consultaSubscription?: Subscription;
  private temporizadorBusqueda?: ReturnType<typeof setTimeout>;

  public idSucursal!: string;
  public nombreSucursal: string = "";
  public perfil: string = '';
  public ordenes: any[] = [];
  public spinnerBoolean: boolean = false;
  public estadoFiltro: string = 'pendiente';

  public fechaInicio = '';
  public fechaFin = '';
  public pagina = 0;
  public busqueda = '';
  public limite = 10;
  public recordsTotal = 0;
  public recordsFiltered = 0;
  
  constructor(private ordenesService: OrdenesService,
    private authService: AuthService,
    private toastr: ToastrService,
    public router: Router) { 
      this._usuario = authService.loginUsuario;
    }

  ngOnInit(): void {
    this.idSucursal = this._usuario.sucursal!;
    this.nombreSucursal = this._usuario.nombreSucursal!;
    this.perfil = this._usuario.perfil!;
    
    this.datatablePanoramica();
  }

  ngOnDestroy(): void {
    this.consultaSubscription?.unsubscribe();
    if (this.temporizadorBusqueda) {
      clearTimeout(this.temporizadorBusqueda);
    }
  }

  datatablePanoramica(){
    this.spinnerBoolean = true;
    this.consultaSubscription?.unsubscribe();
    this.consultaSubscription = this.ordenesService.dtPanoramica(
      this.estadoFiltro,
      this.idSucursal,
      this.fechaInicio,
      this.fechaFin,
      this.pagina,
      this.busqueda,
      this.limite
    ).subscribe({
      next: (resp) => {
        if (!Array.isArray(resp?.data)) {
          this.mostrarErrorConsulta(resp);
          return;
        }

        this.ordenes = resp.data;
        this.recordsTotal = Number(resp?.recordsTotal) || 0;
        this.recordsFiltered = Number(resp?.recordsFiltered) || 0;
        this.spinnerBoolean = false;

        if (this.pagina > 0 && this.ordenes.length === 0) {
          const ultimaPagina = Math.max(this.totalPaginas - 1, 0);
          const ultimoInicio = ultimaPagina * this.limite;
          if (ultimoInicio !== this.pagina) {
            this.pagina = ultimoInicio;
            this.datatablePanoramica();
          }
        }
      },
      error: (error) => {
        this.mostrarErrorConsulta(error);
      }
    });
  }

  private mostrarErrorConsulta(error: any): void {
    this.ordenes = [];
    this.recordsTotal = 0;
    this.recordsFiltered = 0;
    this.spinnerBoolean = false;
    this.toastr.error(
      error?.error?.message ||
        error?.message ||
        'No se pudo consultar las órdenes panorámicas',
      'Atención',
      {
        timeOut: 5000,
        closeButton: true,
        progressBar: true
      }
    );
  }

  filtrarPanoramicaFechas(){
    if (this.temporizadorBusqueda) {
      clearTimeout(this.temporizadorBusqueda);
    }
    this.pagina = 0;
    this.datatablePanoramica();
  }

  programarBusqueda(valor: string): void {
    this.busqueda = valor || '';
    if (this.temporizadorBusqueda) {
      clearTimeout(this.temporizadorBusqueda);
    }
    this.temporizadorBusqueda = setTimeout(() => {
      this.pagina = 0;
      this.datatablePanoramica();
    }, 350);
  }

  cambiarLimite(valor: string | number): void {
    this.limite = Number(valor) || 10;
    this.pagina = 0;
    this.datatablePanoramica();
  }

  irPagina(numeroPagina: number): void {
    const paginaDestino = Math.min(
      Math.max(numeroPagina, 1),
      this.totalPaginas
    );
    const nuevoInicio = (paginaDestino - 1) * this.limite;
    if (nuevoInicio === this.pagina) return;

    this.pagina = nuevoInicio;
    this.datatablePanoramica();
  }

  get paginaActual(): number {
    return Math.floor(this.pagina / this.limite) + 1;
  }

  get totalPaginas(): number {
    return Math.max(Math.ceil(this.recordsFiltered / this.limite), 1);
  }

  get paginasVisibles(): number[] {
    const inicio = Math.max(
      1,
      Math.min(this.paginaActual - 2, this.totalPaginas - 4)
    );
    const fin = Math.min(this.totalPaginas, inicio + 4);
    return Array.from(
      { length: fin - inicio + 1 },
      (_, indice) => inicio + indice
    );
  }

  get registroInicial(): number {
    return this.recordsFiltered > 0 ? this.pagina + 1 : 0;
  }

  get registroFinal(): number {
    return Math.min(this.pagina + this.ordenes.length, this.recordsFiltered);
  }

    /* -------------------------------------------------------------------------- */
  /*                               FACTURAR ORDEN                               */
  /* -------------------------------------------------------------------------- */
  subirImagenes(idOrden) {
    this.router.navigate(['/sistema/subir-imagenes-panoramica', this.makeid(100) + idOrden + this.makeid(100)]);
  }

    /* -------------------------------------------------------------------------- */
  /*                           GENERAR ALEATORIO ROUTE                          */
  /* -------------------------------------------------------------------------- */
  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJ12345679KLMNOPQRST08765454UVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

}
